import { Dialog } from "primereact/dialog";
import FileTypeCard from "./FileTypeCard";
import multipleFilesIcon from "../../../../../assets/muliple-files.svg";

const PayslipFileTypeModal = ({ visible, closeModal, openFileUploadModal }) => {
  return (
    <Dialog
      visible={visible}
      onHide={closeModal}
      style={{ width: "50vw" }}
      draggable={false}
      className="payslip-filetype"
    >
      <div className="payslip-filetype-header">
        <div className="header-title-container flex flex-column gap-2">
          <p className="title">Upload Payslips</p>
          <p className="description">
            Choose the format of your files so we can process them and assign
            them correctly.
          </p>
        </div>
        <i
          className="pi pi-times cross-icon mr-0"
          onClick={closeModal}
          style={{ cursor: "pointer" }}
        />
      </div>

      <div className="content flex">
        <FileTypeCard
          openFileUploadModal={() => openFileUploadModal("single")}
          Icon={() => <i className="pi pi-file" />}
          title="Single PDF File"
          description="A single file that includes all employee payslips. We’ll split them and assign them individually."
        />
        <FileTypeCard
          openFileUploadModal={() => openFileUploadModal("multiple")}
          Icon={() => <img src={multipleFilesIcon} alt="multiple-files" />}
          title="Multiple PDF Files"
          description="A batch of individual payslip files, one per employee. We’ll help you assign them after upload."
        />
      </div>
    </Dialog>
  );
};

export default PayslipFileTypeModal;
